import React from 'react';

const ForecastReport = ({ salesForecast, reportParams, setReportParams, loadSalesForecast }) => {
  return (
    <div>
      <div>
        <div style={{ border: '1px solid var(--border)', borderRadius: '0.375rem', backgroundColor: 'var(--card-bg)' }}>
          <div style={{ padding: '0.5rem', backgroundColor: 'var(--bg)', borderBottom: '1px solid var(--border)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h5 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>📈 Prognoza sprzedaży na {reportParams.forecast_days} dni</h5>
              <input
                type="number"
                style={{
                  width: '80px',
                  padding: '6px 10px',
                  fontSize: '12px',
                  border: '1px solid var(--border)',
                  borderRadius: '6px',
                  backgroundColor: 'var(--card-bg)',
                  color: 'var(--text)'
                }}
                value={reportParams.forecast_days}
                onChange={(e) => {
                  setReportParams({...reportParams, forecast_days: parseInt(e.target.value) || 30});
                }}
                onBlur={() => loadSalesForecast(reportParams)}
                min="1"
                max="365"
              />
            </div>
          </div>
          <div style={{ padding: '0.75rem' }}>
            {salesForecast.forecasts?.length > 0 ? (
              <div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.5rem', marginBottom: '0.75rem' }}>
                  <div style={{ backgroundColor: 'var(--bg)', border: '1px solid var(--border)', borderRadius: '0.25rem', padding: '0.5rem', textAlign: 'center' }}>
                    <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>Produkty analizowane</div>
                    <div style={{ fontSize: '0.9rem', fontWeight: '600', color: 'var(--info)' }}>{salesForecast.total_products}</div>
                  </div>
                  <div style={{ backgroundColor: 'var(--bg)', border: '1px solid var(--border)', borderRadius: '0.25rem', padding: '0.5rem', textAlign: 'center' }}>
                    <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>Okres analizy</div>
                    <div style={{ fontSize: '0.9rem', fontWeight: '600', color: 'var(--info)' }}>{salesForecast.analysis_period} dni</div>
                  </div>
                  <div style={{ backgroundColor: 'var(--bg)', border: '1px solid var(--border)', borderRadius: '0.25rem', padding: '0.5rem', textAlign: 'center' }}>
                    <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>Prognoza łączna</div>
                    <div style={{ fontSize: '0.9rem', fontWeight: '600', color: 'var(--success)' }}>
                      {parseFloat(salesForecast.forecasts.reduce((sum, f) => sum + parseFloat(f.forecast.total_forecast || 0), 0)).toFixed(0)} szt.
                    </div>
                  </div>
                  <div style={{ backgroundColor: 'var(--bg)', border: '1px solid var(--border)', borderRadius: '0.25rem', padding: '0.5rem', textAlign: 'center' }}>
                    <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>Wartość prognoza</div>
                    <div style={{ fontSize: '0.9rem', fontWeight: '600', color: 'var(--warning)' }}>
                      {parseFloat(salesForecast.forecasts.reduce((sum, f) => sum + parseFloat(f.revenue_forecast.estimated_revenue || 0), 0)).toFixed(2)} zł
                    </div>
                  </div>
                </div>

                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.7rem' }}>
                    <thead>
                      <tr>
                        <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Produkt</th>
                        <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Stan</th>
                        <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Śr. dzienna</th>
                        <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Prognoza ({reportParams.forecast_days}d)</th>
                        <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Trend</th>
                        <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Akcja</th>
                        <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Wartość</th>
                      </tr>
                    </thead>
                    <tbody>
                      {salesForecast.forecasts.slice(0, 15).map((forecast) => (
                        <tr key={forecast.product_id}>
                          <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>
                            <div>
                              <div style={{ fontWeight: '600', fontSize: '0.65rem' }}>{forecast.product_name}</div>
                              <div style={{ color: 'var(--text-muted)', fontSize: '0.6rem' }}>{forecast.product_code}</div>
                            </div>
                          </td>
                          <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>
                            <span style={{
                              backgroundColor: forecast.current_stock < forecast.forecast.total_forecast ? 'var(--danger)' : 'var(--success)',
                              color: '#fff' ,
                              padding: '0.1rem 0.2rem',
                              borderRadius: '0.2rem',
                              fontSize: '0.6rem'
                            }}>
                              {forecast.current_stock}
                            </span>
                          </td>
                          <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>{forecast.forecast.daily_forecast}</td>
                          <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>
                            <div style={{ fontWeight: '600' }}>{forecast.forecast.total_forecast}</div>
                            <div style={{ color: 'var(--text-muted)', fontSize: '0.6rem' }}>
                              ±{forecast.forecast.confidence_level}
                            </div>
                          </td>
                          <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>
                            <span style={{
                              backgroundColor: forecast.historical_data.sales_trend === 'wzrostowy' ? 'var(--success)' :
                                forecast.historical_data.sales_trend === 'spadkowy' ? 'var(--danger)' : 'var(--text-muted)',
                              color: '#fff' ,
                              padding: '0.1rem 0.2rem',
                              borderRadius: '0.2rem',
                              fontSize: '0.6rem'
                            }}>
                              {forecast.historical_data.sales_trend}
                            </span>
                          </td>
                          <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>
                            {forecast.inventory_recommendations.reorder_needed ? (
                              <div>
                                <span style={{ border: '1px solid var(--warning)', color: 'var(--warning)' , padding: '0.1rem 0.2rem', borderRadius: '0.2rem', fontSize: '0.6rem' }}>Zamów</span>
                                <div style={{ fontSize: '0.6rem', color: 'var(--text-muted)' }}>
                                  {forecast.inventory_recommendations.suggested_order_quantity} szt.
                                </div>
                              </div>
                            ) : (
                              <span style={{ border: '1px solid var(--success)', color: 'var(--success)' , padding: '0.1rem 0.2rem', borderRadius: '0.2rem', fontSize: '0.6rem' }}>OK</span>
                            )}
                          </td>
                          <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>
                            {parseFloat(forecast.revenue_forecast.estimated_revenue || 0).toFixed(2)} zł
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.8rem' }}>Brak danych do prognozy</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForecastReport;
